import React, {FC, useCallback} from 'react';

import {useAppDispatch} from '../../../../../helpers/reduxHelpers';
import {AttachmentStatusesEnum} from '../../../../../models/api/attachmentModel';
import {
  downloadAttachmentAsync,
  DownloadAttachmentOptions,
  previewAttachmentAsync,
  PreviewAttachmentOptions,
} from '../../../../../services/browser';
import {maybePopupEmlPanel} from '../../../../../store/panels/eml/emlPanelHelpers';
import {AttachmentBase, AttachmentBasePublicProps} from './attachmentBase';

/*
 * Component.
 */

export const AttachmentBaseContainer: FC<AttachmentBasePublicProps> = (props) => {
  const {attachment} = props;
  const dispatch = useAppDispatch();

  const onPreviewClickAsync = useCallback(
    async (options: PreviewAttachmentOptions) => {
      if (attachment.status !== AttachmentStatusesEnum.UPLOADED) {
        throw new Error('Only uploaded attachments can be previewed.');
      }

      if (maybePopupEmlPanel(attachment, dispatch)) {
        return;
      }

      await previewAttachmentAsync(attachment, options);
    },
    [attachment, dispatch],
  );

  const onDownloadClickAsync = useCallback(
    (options: DownloadAttachmentOptions) => {
      if (attachment.status !== AttachmentStatusesEnum.UPLOADED) {
        throw new Error('Only uploaded attachments can be downloaded.');
      }

      return downloadAttachmentAsync(attachment, options);
    },
    [attachment],
  );

  return (
    <AttachmentBase
      {...props}
      onPreviewClickAsync={onPreviewClickAsync}
      onDownloadClickAsync={onDownloadClickAsync}
    />
  );
};
